import React from "react";
import Link from "next/link";
import Image from "next/image";
import { GetStaticProps } from "next";
import SeoHeader from "@/components/common/Seo/SeoHeader";
import { FiUsers } from "react-icons/fi";
import { TbQrcode } from "react-icons/tb";
import { AiOutlineScan } from "react-icons/ai";
import { Button } from "@/components/common/Button";
import Banner from "@/components/common/Banner/Banner";
import Layout from "@/components/layout/Layout";
import Container from "@/components/common/Container/Container";
import { useRegisterTrack } from "@/states/user.state";
import style from "@/styles/about/About.module.scss";
const chartData = [{
  id: 1,
  icon: <TbQrcode color="#0A9396" size={30} />,
  count: 5,
  desc: "QR Codes generated"
}, {
  id: 1,
  icon: <FiUsers color="#0A9396" size={30} />,
  count: 2,
  desc: "Active users"
}, {
  id: 1,
  icon: <AiOutlineScan color="#0A9396" size={30} />,
  count: 25,
  desc: "Clicks & scans every month"
}];
const About = () => {
  const {
    setRegisterTrack
  } = useRegisterTrack();
  const handleRegisterTrack = () => setRegisterTrack("/about");
  return <Layout nav footer data-sentry-element="Layout" data-sentry-component="About" data-sentry-source-file="index.tsx">
      <SeoHeader seoTitle="About Us - QR Code Creator" seoDescription="Our team of professional developers and designers joined forces to design a user-friendly QR code generator. " noIndex={true} data-sentry-element="SeoHeader" data-sentry-source-file="index.tsx" />
      <div>
        <Banner title="About Us" type="multi" data-sentry-element="Banner" data-sentry-source-file="index.tsx" />
        <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <div className={style.box}>
            <div className={style.about_item}>
              <h2 className={style.title}>Our Story</h2>
              <p className={style.subtitle}>Who We Are</p>
              <p className={style.desc}>
                Our team of professional developers and designers joined forces to design a
                user-friendly QR code generator. After long brainstorming sessions and research,
                we’ve discovered two qualities - creative QR codes and the variety of types make QR
                code generators stand out. Following several ups and downs, trials and tribulations,
                we’ve checked all the boxes to offer you an innovative QR Code Creator.
              </p>
            </div>
            <div className={style.img_box}>
              <Image src={"/home-page/about.svg"} width={633} height={360} alt="about" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
            </div>
            <div className={style.about_item}>
              <h2 className={style.title}>Our Mission</h2>
              <p className={style.subtitle}>We suceed when our users do</p>
              <p className={style.desc}>
                QR Codes are convenient portals leading you to the digital world. Our primary goal
                is to provide you with a simple yet rich in variety QR Code Generator. It will help
                industries to leverage their businesses and individuals to incorporate QR codes into
                their personal lives.
              </p>
            </div>
            <div className={style.chart}>
              <h2 className={style.title}>QR Code Creator by the Numbers</h2>
              <p className={style.subtitle}>Our services attract people from all over the world</p>
              <div className={style.flex}>
                {chartData.map(item => <div className={style.item} key={item.id}>
                    <span className={style.cover}>{item.icon}</span>
                    <div className={style.item__title}>
                      {item.count} <span>million +</span>{" "}
                    </div>
                    <p className={style.item__des}>{item.desc}</p>
                  </div>)}
              </div>
            </div>
            <div className={style.create}>
              <div className={style.left}>
                <div className={style.title}>Make your materials stand out</div>
                <p className={style.des}>
                  Don’t just edit track and brand your QR codes and forget about them. Print them on
                  anything you like right now and give your campaign more exposure.
                </p>
              </div>
              <div>
                <Link href={"/register"} data-sentry-element="Link" data-sentry-source-file="index.tsx">
                  <Button variant="primary" title="Sign up now" className={style.btn_sign_up} onClick={handleRegisterTrack} data-sentry-element="Button" data-sentry-source-file="index.tsx" />
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Layout>;
};
export default About;